// Import project modules
import { functions, database, dbRef, httpsCallable, push } from './initFirebase.js';
import { randomHash, url } from './_default.js';

const activities = {
  publicId: null,
  name: null,
  activityTypes: {
    pageLoad: 'page_load',
    signup: 'signup',
    logout: 'logout',
    login: 'login',
    deleteAccount: 'delete_account',
    updatedProfile: 'updated_profile',
    errorSeen: 'error_seen',
    requestedLoginCode: 'requested_login_code',
    sendChatMessage: 'send_chat_message',
  },

  initAndTrackPageview: async function() {
    console.log('initAndTrackPageview')
    // Check if activity visitor id is set
    let publicId = localStorage.getItem('publicId');
    
    // Check url, if url parameter is set and no localStorage is set
    if(url.parameters.pId){
      publicIdFromUrl = url.parameters.pId;
      publicIdFromLocalStorage = localStorage.getItem('publicId') || null;

      //localStorage.setItem('publicId', publicId);
      const getNameFromPublicIdResponse = await httpsCallable(functions, 'handlePublicIdFromUrl')({ publicIdFromUrl, publicIdFromLocalStorage });
      console.log({publicIdFromUrl, publicIdFromLocalStorage, getNameFromPublicIdResponse});
      if(getNameFromPublicIdResponse?.data?.success && getNameFromPublicIdResponse?.data?.name){
        activities.updateName(getNameFromPublicIdResponse.data.name);
        localStorage.setItem('publicId', publicIdFromUrl);
      }
    }else if(!publicId){
      publicId = randomHash(20);
      localStorage.setItem('publicId', publicId);
    }

    // Set visitor id
    activities.publicId = publicId;

    // Set visitor name
    activities.name = localStorage.getItem('name') || `Anonymous ${publicId.substr(0, 2)}`;

    // Log page load
    activities.log(activities.activityTypes.pageLoad, null);
  },

  updateName: function(name) {
    console.log('updateName')

    activities.name = name;
    localStorage.setItem('name', name);
  },

  log: async function(activityType, additionalData) {
    console.log('log')

    const createdAt = new Date().toISOString();
    const publicId = activities.publicId;
    const name = activities.name;
    const userAgent = navigator.userAgent;

    if(!additionalData) {
      additionalData = null;
    }else if(additionalData.updates?.email){
      additionalData.updates.email = '{hiding}'
    }

    try {
      // Push the log data to the Realtime Database
      const activityLogsRef = dbRef(database, 'activityLogs');
      await push(activityLogsRef, { createdAt, publicId, name, activityType, url: url.href, additionalData, userAgent });
    } catch (error) {
      console.error('Error logging activity:', error);
    }
  }

};

// For debugging
window.activities = activities;

export { activities };